var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#34544F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 28.5a.6.6 0 0 1-.6-.6c0-.4.3-.6.6-.6a4.3 4.3 0 0 0 0-8.6c-2.3 0-4.2 2-4.2 4.3 0 .3-.3.6-.6.6a.6.6 0 0 1-.6-.6 5.5 5.5 0 1 1 5.4 5.5Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 17.5c.3 0 .6.3.6.6s-.3.6-.6.6a4.3 4.3 0 0 0 0 8.6c2.3 0 4.2-2 4.2-4.3 0-.3.3-.6.6-.6.4 0 .6.3.6.6a5.5 5.5 0 1 1-5.4-5.5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlink);
export default __webpack_public_path__ + "static/media/unlink.cfd8829f3a3b575bece30f730fbf93c4.svg";
export { ForwardRef as ReactComponent };